// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OSmp0S3bHqFWwtXb1IuN {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.hy7IVU4HXC25u67e0akL {
  width: 100%;
  height: 100%;
  padding: 24px;
}

.fOCD9UBBdRjOVGz5GEQR, .AG_1GNxLyZZ18PP3NHGY {
  width: 100%;
  height: 100%;
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.AG_1GNxLyZZ18PP3NHGY {
  background-color: rgba(255, 255, 255, 0.9);
}

.MEE_Y0sJhPw1nCYWTbrc {
  padding: 24px;
}

.mBcXOTqkADwBc6dHx3NT {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  column-gap: 32px;
}

.em6BsDHdnztDg_wBDYIM {
  max-height: 65vh;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow-y: auto;
  min-height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/Components/DraftEditor/DraftEditor.module.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAAF;;AAIA;EAEE,0CAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,0CAAA;EACA,gBAAA;EACA,iBAAA;AAFF","sourcesContent":["\r\n.draftEditorContainer {\r\n  position: fixed;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.editorOuterContainer {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 24px;\r\n}\r\n\r\n.editorWrapperDark {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 16px;\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n  border-radius: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n\r\n}\r\n\r\n.editorWrapperLight {\r\n  @extend .editorWrapperDark;\r\n  background-color: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.darkModeButtonContainer {\r\n  padding: 24px;\r\n}\r\n\r\n.editorFooter {\r\n  width: 100%;\r\n  height: 50px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-end;\r\n  column-gap: 32px;\r\n}\r\n\r\n.draftInnerWrapper {\r\n  max-height: 65vh;\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  overflow-y: auto;\r\n  min-height: 300px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"draftEditorContainer": `OSmp0S3bHqFWwtXb1IuN`,
	"editorOuterContainer": `hy7IVU4HXC25u67e0akL`,
	"editorWrapperDark": `fOCD9UBBdRjOVGz5GEQR`,
	"editorWrapperLight": `AG_1GNxLyZZ18PP3NHGY`,
	"darkModeButtonContainer": `MEE_Y0sJhPw1nCYWTbrc`,
	"editorFooter": `mBcXOTqkADwBc6dHx3NT`,
	"draftInnerWrapper": `em6BsDHdnztDg_wBDYIM`
};
export default ___CSS_LOADER_EXPORT___;
